export default __webpack_public_path__ + "static/media/dysfunctional_family.2c6a948d.jpg";